import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  NkContainer,
  NkStack,
  NkEntry,
  NkGroup,
  NkGrid,
  NkBox,
  NkHeading,
  NkText,
  NkCol,
  NkIcon,
} from '@/core/components';

import NkUserUpdateMailForm from '@/entities/user/components/UserUpdateMailForm.vue';
import NkUserUpdatePasswordForm from '@/entities/user/components/UserUpdatePasswordForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkUserProfile',
  setup(__props) {

const { t } = useI18n();

const sections = reactive([
  {
    name: t('profile.tab.general'),
    id: 1,
  },
  {
    name: t('profile.tab.password'),
    id: 2
  }
]);

const activeSection = ref(1);

return (_ctx: any,_cache: any) => {
  return (_ctx.$route.name === 'visionair-profile')
    ? (_openBlock(), _createBlock(_unref(NkContainer), {
        key: 0,
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkStack), { spacing: 8 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkBox), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NkHeading), { type: "underlined" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('profile.title')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(NkEntry), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkGrid), { justify: "between" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NkCol), { md: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NkStack), null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections, (section) => {
                                return (_openBlock(), _createBlock(_unref(NkText), {
                                  key: section.id,
                                  class: _normalizeClass(["cursor-pointer p-2", {
                    'text-white bg-primary rounded': section.id === activeSection.value,
                  }]),
                                  onClick: ($event: any) => (activeSection.value = section.id)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(section.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NkCol), { md: 9 }, {
                        default: _withCtx(() => [
                          (activeSection.value === 1)
                            ? (_openBlock(), _createBlock(_unref(NkStack), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NkHeading), { type: "small-bold" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('profile.general_infos.title')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(NkGroup), { spacing: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NkIcon), {
                                        class: "text-danger",
                                        name: "NkInfo"
                                      }),
                                      _createVNode(_unref(NkText), {
                                        class: "!text-danger",
                                        type: "extra-small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('profile.update_email.info')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(NkUserUpdateMailForm)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (activeSection.value === 2)
                            ? (_openBlock(), _createBlock(_unref(NkStack), { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NkHeading), { type: "small-bold" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('profile.password_change.title')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(NkUserUpdatePasswordForm)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})